import { Button, FileUpload, FormField } from "@wix/design-system";
import React, { useContext, useState } from "react";
import { fromFile } from "./../../bundled-dependencies/id3js";
import { EditorContext, PluginsEventsContext, RicosContext, UploadContext } from "./../../ricos-context";
import { MEDIA_POPOVERS_BUTTONS_NAMES_BI } from "./../../wix-rich-content-common";
import { Uploader } from "./../../plugin-commons";
import { useBiNext } from "../../_shared/use-bi-next";
import { audioFileTypes } from "../consts";
import { UPLOAD_TAB_UPLOAD_BUTTON } from "../dataHooks";
import { RICOS_DEFAULTS } from "../defaults";
import { AudioPluginService } from "../toolbar/audioPluginService";
import { AUDIO_TYPE } from "../types";
const AudioUpload = ({
  nodeId,
  handleFileSelection,
  handleFileUpload,
  closeModal
}) => {
  const { t } = useContext(RicosContext);
  const { getEditorCommands } = useContext(EditorContext);
  const { uploadService, updateService } = useContext(UploadContext);
  const pluginsEvents = useContext(PluginsEventsContext);
  const logBi = useBiNext();
  const hasCustomFileUpload = Boolean(handleFileUpload || handleFileSelection);
  const [audioPluginService] = useState(new AudioPluginService());
  const handleUploadClick = () => {
    pluginsEvents.publishPluginPopoverClick?.({
      pluginId: AUDIO_TYPE,
      buttonName: MEDIA_POPOVERS_BUTTONS_NAMES_BI.upload
    });
    logBi({ dataHook: UPLOAD_TAB_UPLOAD_BUTTON });
    if (handleFileSelection) {
      handleFileSelection(
        handleExternalFileChange(nodeId, getEditorCommands(), updateService, audioPluginService)
      );
      closeModal();
      return;
    }
    uploadService?.selectFiles(
      audioFileTypes,
      false,
      handleNativeFileChange(
        nodeId,
        getEditorCommands(),
        uploadService,
        new Uploader(handleFileUpload),
        audioPluginService
      )
    );
    closeModal();
  };
  return /* @__PURE__ */ React.createElement(FormField, { label: t("AudioModal_Upload_Title"), maxLines: 2 }, hasCustomFileUpload ? /* @__PURE__ */ React.createElement(FileUpload, { onChange: () => {
  }, accept: audioFileTypes }, () => /* @__PURE__ */ React.createElement(
    Button,
    {
      dataHook: UPLOAD_TAB_UPLOAD_BUTTON,
      onClick: handleUploadClick,
      fullWidth: true,
      size: "small"
    },
    t("AudioModal_Upload_ButtonText")
  )) : null);
};
const handleExternalFileChange = (nodeId, editorCommands, updateService, audioPluginService) => ({ data }) => {
  const id = nodeId || editorCommands.insertBlockWithBlankLines(AUDIO_TYPE, RICOS_DEFAULTS);
  const file = data instanceof Array ? data[0] : data;
  setTimeout(() => {
    updateService?.updatePluginData({ data: file }, id, AUDIO_TYPE, audioPluginService);
  });
};
const handleNativeFileChange = (nodeId, editorCommands, uploadService, uploader, audioPluginService) => (files) => {
  const file = files instanceof Array ? files[0] : files;
  getAudioTags(file).then((tags) => {
    const id = nodeId || editorCommands.insertBlockWithBlankLines(AUDIO_TYPE, { ...RICOS_DEFAULTS, ...tags });
    setTimeout(() => {
      uploadService.uploadFile(
        new File([file], file.name, { type: file.type }),
        id,
        uploader,
        AUDIO_TYPE,
        audioPluginService
      );
    });
  });
};
const getAudioTags = async (file) => {
  try {
    const tags = await fromFile(file);
    return { name: tags?.title, authorName: tags?.artist };
  } catch (error) {
    console.error(error);
    return {};
  }
};
export {
  AudioUpload
};
//# sourceMappingURL=audio-upload.js.map
